import {Divider, Stack, styled, Typography} from '@mui/material';

const StyledSectionDescription = styled(Stack)`
	justify-content: center;
	align-items: center;
	text-align: center;
	gap: 16px;
	overflow: hidden;
`;

const StyledProtocolRow = styled(Stack)`
	flex-direction: row;
	gap: 8px;
`;

const StyledIconPosition = styled(Stack)`
	padding-top: 4px;
`;

const StyledConfirmButtonContainer = styled(Stack)`
	width: 100%;
`;

const StyledFooterDescriptionContainer = styled(Typography)`
	color: ${({theme}) => theme.palette.text.secondary};
	text-align: left;
`;

const StyledDivider = styled(Divider)`
	margin-bottom: 8px;
`;
export {
	StyledSectionDescription,
	StyledProtocolRow,
	StyledIconPosition,
	StyledConfirmButtonContainer,
	StyledFooterDescriptionContainer,
	StyledDivider,
};
